import { CameraContext } from '@/pages/(gapsdk)/_provider/sdk-camera-provider';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import { QrCode } from 'lucide-react';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CameraScanner from '../_components/camera';
import InputCode from '../_components/input-code';
import KeyboardCustom from '../_components/key-board-custom';
import Scanner from '../_components/scanner';
import TopNavigation from '../_components/top-navigation';

export default function VerifyGiftCardPage() {
  const { event: eventSound } = useContext(SoundContext);
  const navigate = useNavigate();
  const [showKeyboard, setShowKeyboard] = useState(false);
  const { camera } = useContext(CameraContext);

  return (
    <>
      <TopNavigation onBack={() => navigate(`/gift-card`)} />
      <div className="flex h-full flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-6">
          {!showKeyboard ? (
            <>
              <div className="flex w-full items-center justify-center gap-6">
                {camera ? (
                  <CameraScanner />
                ) : (
                  <div className="border-sliver flex size-[400px] flex-col items-center justify-center rounded-lg border border-silver p-4">
                    <span className="text-4xl font-bold">Scan QR Code</span>
                    <QrCode size={400} />
                  </div>
                )}
              </div>

              <InputCode
                onShowKeyboard={() => {
                  setShowKeyboard(true);
                  eventSound.playTap();
                }}
              />
            </>
          ) : (
            <KeyboardCustom
              onCheckSuccess={(code) => {
                navigate(`/gift-card/information/${code.split('-').join('')}`);
              }}
            />
          )}
        </div>
        {!showKeyboard && <Scanner />}
      </div>
    </>
  );
}
